// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { BiteBalanceClient as ContractsClient } from "@bitebalance/contracts/client"
import { withConsumptionHistory, type WithConsumptionHistory } from "./consumptionHistory"
import { withRecipePortion, type RecipePortionClient } from "./recipePortion"
import type { WebRequestDeps } from "./webGet"

export type WebClientDeps = WebRequestDeps

/**
 * The web app's client: the generated `@bitebalance/contracts` client plus
 * the web-only extensions (`getRecipe(id, {servings})`, ADR-056
 * `getConsumptionHistory({from, to})`) — composed ONCE here so the real
 * client (api/client.ts) and the handler-backed test client
 * (test/testApiClient.ts) can never drift on which operations exist.
 */
export type BiteBalanceClient = WithConsumptionHistory<RecipePortionClient>

export function withWebExtensions(client: ContractsClient, deps: WebClientDeps): BiteBalanceClient {
  return withConsumptionHistory(withRecipePortion(client, deps), deps)
}
